import axios from 'axios'
import { StandardThunkAction } from '../store/store'
import { getUserDetails } from './session'
import { CLEAR_REGISTER_NAV_STATE } from './types/actions'
import { RegisterFields } from './types/register'
import { StandardApiResponse } from './types/responses'
import { isApiError } from './utils'


export const clearRegisterNavState = (): StandardThunkAction => {
    return async(dispatch): Promise<void> => {
        dispatch({ type: CLEAR_REGISTER_NAV_STATE })
    }
}

export const register = ({ confirmEmail: email_confirmation, confirmPassword: password_confirmation, activationCode: activation_code, ...restpayload}: RegisterFields): StandardThunkAction<StandardApiResponse> => {
   return async(dispatch): Promise<StandardApiResponse> => {
    try {
        const { data } = await axios.post('/api/register', { ...restpayload, email_confirmation, password_confirmation, activation_code })

        if(data.success) {
            return { ...data }
        } else if(data.message) {
            return { success: false, errors: [data.message] }
        } else {
            return { ...data, errors: ['An unkown error occured and registration failed'] }
        }
    } catch (error: any) {
        if(isApiError(error)) {
            const { errors: apiErrors, message } = error.response?.data || { }
            let errors: string[] = []
            if(message) {
                errors = [message]
            }
            if(apiErrors) {
                const mappedErrors = Object.keys(apiErrors).reduce((accum: string[], key: string) => {
                    const item = apiErrors[key] || []
    
                    return [...accum, ...item]
                }, [])

                errors = [...errors, ...mappedErrors]
            }

            return { success: false, errors }
        }
        return { success: false }
    }
   }
}